import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, Observable, ReplaySubject } from 'rxjs';
import { ZpmTileConfig } from '../../../shared/models/generated/ziroModels';
import { map, take } from 'rxjs/operators';
import { MicrosoftTenantsStateContext } from '../../../shared/contexts/microsoft-tenants-state.context';

@Injectable()
export class MicrosoftTileConfigContext {
  private http = inject(HttpClient);
  private _tenantsStateContext = inject(MicrosoftTenantsStateContext);

  private _stateSource = new ReplaySubject<ZpmTileConfig>(1);
  state$ = this._stateSource.asObservable();
  private _tenantId: string;

  constructor() {
    this._tenantsStateContext.cachedTenantState$
      .pipe(
        filter((cachedTenant) => !!cachedTenant?.tenantId),
        take(1),
      )
      .subscribe((cachedTenant) => {
        this._tenantId = cachedTenant.tenantId.toString();
        this.refresh().subscribe();
      });
  }

  refresh(): Observable<void> {
    return this._get().pipe(map((tileConfig) => this._stateSource.next(tileConfig)));
  }

  private _get(): Observable<ZpmTileConfig> {
    return this.http.get<ZpmTileConfig>(`/services/microsoft/field-configs/tenants/${this._tenantId}/tile-configs`);
  }
}
